import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/implied-volatility-calculator',
  component: () => import('../../routes/ImpliedVolatilityCalculator.svelte'),
  card: {
    id: 'implied-volatility-calculator',
    title: 'Implied Volatility Calculator',
    description:
      'Calculate the implied volatility of an option from its market price using the Black-Scholes model — reverse-engineer what volatility the market is pricing in.',
    icon: 'speed',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/implied-volatility-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Implied Volatility Calculator — Reverse-Engineer Market Volatility',
    description:
      'Calculate implied volatility from an option\'s market price using the Black-Scholes model. Understand what volatility the market expects for any options contract.',
  },
};

export default meta;
